module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Since Stephen F. Austin State University (SFA) opened its doors in 1923, thousands of athletes and coaches and many more thousands of fans have experienced what Jim McKay called “the thrill of victory and the agony of defeat” on athletic fields and courts and other arenas of competition in the Lone Star, Gulf Star, and Southland Conferences. Each played a role in the Lumberjack/ Ladyjack story, and we wish to acknowledge them first. Then, we thank athletic director Robert Hill, associate director Matt Fenley, and assistant director John Branch for seeing the potential in this project and sports information officers James Dixon and Brian Ross and athletic department staff member Crystal Shaw for identifying athletes and providing information about them. Linda Reynolds aided our search in the records of the East Texas Research Center, and Gary Russell, John Levra, Lynn Graves, and Buddy Lowery generously loaned personal pictures for our use. As always, appreciation is especially extended to Portia Gordon for deciphering the publisher’s prescriptions and arranging a format that our conscientious and always cheerful editor, Luke Cunningham, would accept.")])])])]), _c('a', {
    attrs: {
      "id": "title1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6afccb74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439638378_ack01.vue
// module id = 72
// module chunks = 0